import { WidgetsParcelDetailMain } from '@/widgets/parcel-detail';

export const PagesParcelDetailMain = () => <WidgetsParcelDetailMain />;
